import React from "react";
import "./Website_ugread.css";
import { FaVolumeUp } from "react-icons/fa";
import { faFire } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";

function Website_ugread() {
  return (
    <>
      <section className="Website_ugread">
        <div className="upgrade-bar">
          <div className="upgrade-left">
            <div className="icon-wrapper">
              <FaVolumeUp />
            </div>
            <p className="upgrade-text">
              The website upgrade is complete. before loffing in clear browser cache.
            </p>
          </div>

          <Button className="btn_register_bg">
            <FontAwesomeIcon icon={faFire} /> Detail
          </Button>
        </div>
      </section>
    </>
  );
}

export default Website_ugread;